import React, { Component, createRef, createContext } from 'react';
import { findDOMNode } from 'react-dom';
import { DropDownBox } from '../../Components/Dropdowns/style';

const { Provider, Consumer } = createContext({});

export const ClickContextConsumer = ({ children }) => (
    <Consumer>{props => <DropDownBox {...props}>{children}</DropDownBox>}</Consumer>
);

export class Delegate extends Component {
    static Click = class extends Component {
        WrapperComponent = createRef();
        state = {
            offsetLeft: 0,
        };

        handleClickOntsideComponent = event => {
            const node = findDOMNode(this.WrapperComponent.current);
            const {
                parentElement: { offsetLeft, offsetTop },
            } = node;
            this.setState({
                offsetLeft,
                offsetTop,
            });

            if (!node.contains(event.target)) {
                this.props.onAction();
            }
        };

        componentDidMount() {
            document.addEventListener('mousedown', this.handleClickOntsideComponent, false);
        }

        componentWillUnmount() {
            document.removeEventListener('mousedown', this.handleClickOntsideComponent, false);
        }

        render() {
            return (
                <span ref={this.WrapperComponent}>
                    <Provider value={this.state}>{this.props.children}</Provider>
                </span>
            );
        }
    };

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/UI/Containers/Delegate/Delegate.js